module.exports = __webpack_public_path__ + "resources/img/retry_screen_customizations.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/retry_screen_customizations.jpg
// module id = 1375
// module chunks = 0